import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import PriceItPlusPerformance from './subcomponents/price-it-plus-performance';

import { PriceItPlus as PriceItPlusIcon } from '../../common/icons';

import './style.css';

class PriceItPlus extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  toggleContent = () => {
    const { isOpen } = this.state;

    this.setState({ isOpen: !isOpen });
  };

  render() {
    const { data } = this.props;
    const { isOpen } = this.state;

    return (
      <div className="user-performance-container">
        <div className="incentive-performances">
          <Panel
            className={isOpen ? 'panel-open' : 'panel-closed'}
            header={(
              <div className="performance-header-container" onClick={this.toggleContent}>
                <div className="performance-header-section performance-title-section">
                  <PriceItPlusIcon height={24} width={24} className="performance-icon" />
                  <h2 className="perfomance-name">
                    {`Price IT Plus - ${data.name}`}
                  </h2>
                </div>
                <div className="performance-header-section">
                  <span className={`dropdown-arrow ${isOpen && 'is-open'}`} />
                </div>
              </div>
            )}
          >
            {isOpen && data && (
              <PriceItPlusPerformance
                data={data}
              />
            )}
          </Panel>
        </div>
      </div>
    );
  }
}

export default PriceItPlus;



// WEBPACK FOOTER //
// ./src/components/store-performance/user-performances/price-it-plus.jsx